import { get } from "lodash";

// -- STATE QUERIES -- //

export const projectsDataMapQuery = state =>
  get(state, "projects.dataMap", undefined);
export const providersDataMapQuery = state =>
  get(state, "providers.dataMap", undefined);
export const regionsDataMapQuery = state =>
  get(state, "regions.dataMap", undefined);

export const servicesQuery = state => get(state, "services.data", undefined);
export const regionsQuery = state => get(state, "regions.data", undefined);
export const imagesQuery = state => get(state, "images.data", undefined);
export const sizesQuery = state => get(state, "sizes.data", undefined);

// using the following export pattern so we can mock more easily using jest

const selectorQueries = {
  projectsDataMapQuery,
  providersDataMapQuery,
  regionsDataMapQuery,

  servicesQuery,
  regionsQuery,
  imagesQuery,
  sizesQuery
};

export default selectorQueries;
